import React from 'react';
import { usePlanningActualState } from '../Context/index';

const MarginRateTotal = ({ years }) => {
  const { checkVisible, getOvarAllFieldTotal } = usePlanningActualState();
  const marginRateOptions = [
    {
      keyName: 'plannedMarginRate',
      name: 'Planned Margin Rate (%)',
    },
    {
      keyName: 'actualMarginRate',
      name: 'Actual Margin Rate (%)',
    },
  ];
  return (years ?? []).map((currentYear, yearIndex) => {
    return (
      <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
        <thead>
          <tr>
            {marginRateOptions.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>
                      {currentYear}&nbsp;
                      {salesItem.name}
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          <tr>
            {marginRateOptions.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return isVisible && <td key={i}>{getOvarAllFieldTotal(salesItem.keyName, yearIndex, currentYear)}</td>;
            })}
          </tr>
        </tbody>
      </table>
    );
  });
};
export default MarginRateTotal;
